export enum Locale {
    'en-US' = 'en-US',
    'en-CA' = 'en-CA',
}

export enum SiteName {
    'en-US' = 'PetSmart',
    'en-CA' = 'PetSmart_CA',
}

export enum Domains {
    'en-US' = 'https://www.petsmart.com',
    'en-CA' = 'https://www.petsmart.ca',
}

export enum LocaleShorthand {
    'en-US' = 'us',
    'en-CA' = 'ca',
}

export enum LocaleShorthandUpper {
    'en-US' = 'US',
    'en-CA' = 'CA',
}

export const DEFAULT_LOCALE = Locale['en-US'];
